const AboutStory = () => {
  return (
    <div className="grid md:grid-cols-2 gap-12 items-center">
      <div className="space-y-6">
        <h2 className="text-3xl md:text-4xl font-light tracking-wide">
          Crafted for the Modern Indian
        </h2>
        <p className="text-gray-600 leading-relaxed text-lg">
          At Ritesh Puri, clothing is more than fashion — it reflects identity, culture, and confidence. Our collections blend timeless style with modern living, crafted from premium fabrics for comfort, durability, and elegance. Inspired by India's textile heritage and global trends, our designs combine tradition with contemporary sophistication, perfect for everyday moments, special occasions, or spontaneous adventures.
        </p>

        {/* <button className="border border-black px-10 py-3 text-sm uppercase tracking-wider hover:bg-black hover:text-white transition">
          Discover Our Story
        </button> */}
      </div>
      <div className="grid grid-cols-2 gap-4">
        <img
          src="./images/home2.jpeg"
          alt="Craft"
          className="w-full h-80 object-cover shadow-lg"
        />
        <img
          src="./images/home6.jpeg"
          alt="Details"
          className="w-full h-80 object-cover shadow-lg mt-8"
        />
      </div>
    </div>
  );
};

export default AboutStory;